module.exports = __webpack_public_path__ + "static/media/signup-img-4.e78bc25c.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/signup-img-4.jpg
// module id = 1408
// module chunks = 0